import React, { useState, useEffect, useReducer, useContext } from "react";
import { Select, Input, Button } from "antd";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import DashboardLayout from "../layout";
import Header from "../header/Header";
import CustomButton from "../shared/common/customButton";
import PDFDownloadButton from "../shared/pdf/pdfDownloadBtn";
import { generateIOR } from "../shared/pdf/generateIOR";
import CountrySelectInput from "../shared/countrySelectInput";
import ServiceTempIOR from "./servicesTemp/tempIOR";
import axios from "axios";
import { api, API_BASE_URL, API_DEPLOYED_URL } from "../../config/api";
import CreatableSelect from "react-select/creatable";
import { useNavigate, useLocation } from "react-router-dom";
import { useMyContext } from "../../context/MyContext";
import { FaArrowLeft, FaCheckCircle } from "react-icons/fa";
import { FaCirclePlus, FaCircleMinus } from "react-icons/fa6";
import Modal from "react-modal";
import { getAlpha2Code } from "../../lib/helper/countryToAphlaCode";
import { Radio } from 'antd';
import {
  calculateServiceValue,
  evaluateComplexFormula,
  evaluateConditionalFormula,
  evaluateSimpleCondition,
  getUniqueHSCodeCount
} from '../../utils/AdminUpdateEstimateUtils';
import { db } from '../../config/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { CurrencyContext } from "../../context/CurrencyContext";

Modal.setAppElement("#root");

const { Option } = Select;

const EstimatedIOR = () => {
  const { user } = useMyContext();
  const { currencies } = useContext(CurrencyContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isNoMatchModalOpen, setIsNoMatchModalOpen] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [eccnCodes, setEccnCodes] = useState([]);
  const [selectedEccn, setSelectedEccn] = useState(null);
  const { estimateId } = useParams();

  // Unit conversion functions
  const convertLbsToKg = (lbs) => {
    return lbs * 0.453592;
  };

  const convertInchesToCm = (inches) => {
    return inches * 2.54;
  };

  const convertKgToLbs = (kg) => {
    return kg / 0.453592;
  };

  const convertCmToInches = (cm) => {
    return cm / 2.54;
  };

  // Helper function to get converted weight in kg
  const getWeightInKg = (weight) => {
    if (!weight || !weight.value) return 0;
    const value = parseFloat(weight.value);
    return weight.unit === 'lbs' ? convertLbsToKg(value) : value;
  };

  // Helper function to get converted dimension in cm
  const getDimensionInCm = (dimension) => {
    if (!dimension || !dimension.value) return 0;
    const value = parseFloat(dimension.value);
    return dimension.unit === 'in' ? convertInchesToCm(value) : value;
  };

  const [values, setValues] = useState({
    userId: user.uid,
    userName: user.name,
    userCity: user.city,
    userCountry: user.country,
    postalCode: user.postalCode,
    email: "",
    status: false,
    requiredDoc: "",
    destinationCity: "",
    originCity: "",
    loadCountry: "",
    originCountry: "",
    unloadCountry: "",
    destinationCountry: "",
    hsCode: "",
    dimensions: [{
      weight: { value: "", unit: "kg" },
      length: { value: "", unit: "cm" },
      width: { value: "", unit: "cm" },
      height: { value: "", unit: "cm" },
      quantity: { value: '' }
    }],
    dimensionUnit: "cm",
    insuranceSelected: 'NO',
    airfreightCurrency: "USD",
    afcWeightUnit: "kg",
    selectedService: "IOR",
    selectedTemplate: {
      name: "",
      services: [],
    },
    iorFee: 0,
    itemsCurrency: "USD",
    items: [],
    eccnCode: null,
  });

  const [validationErrors, setValidationErrors] = useState({});
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const [templateSelected, setTemplateSelected] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [savedServices, setSavedServices] = useState([]);
  const navigate = useNavigate();

  const [itemsTotalQty, setItemsTotalQty] = useState(0); //Items Total Quantity
  const [totalItemsValue, setTotalItemsValue] = useState(0);


  const [totalItemsQuantity, setTotalItemsQuantity] = useState(0); //Box Item Total Quantity

  const [totalDimensionsWeight, setTotalDimensionsWeight] = useState(0);
  const [totalDimensionsLength, setTotalDimensionsLength] = useState(0);
  const [totalDimensionsWidth, setTotalDimensionsWidth] = useState(0);
  const [totalDimensionsHeight, setTotalDimensionsHeight] = useState(0);
  const [insurance, setInsurance] = useState(0);
  const [airfreight, setAirfreight] = useState(0);
  const [cif, setCif] = useState(0);
  const [isCurrencyLoading, setIsCurrencyLoading] = useState(false);

  const getUserCurrency = async (userId) => {
    try {
      const userRef = doc(db, 'users', userId);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const userData = userSnap.data();
        const currency = userData.currency || 'EUR';
        return currency;
      } else {
        return 'EUR';
      }
    } catch (error) {
      console.error('Error fetching user currency:', error);
      return 'EUR';
    }
  };

  const handleDimensionChange = (index, field, e) => {
    const { value, name } = e.target;
    const isUnitChange = name && name.includes('unit');
    setValues(prevValues => {
      const newDimensions = [...prevValues.dimensions];
      if (isUnitChange) {
        if (field === 'height') {
          newDimensions[index].length = { ...newDimensions[index].length, unit: value };
          newDimensions[index].width = { ...newDimensions[index].width, unit: value };
          newDimensions[index].height = { ...newDimensions[index].height, unit: value };
        } else {
          newDimensions[index][field] = { ...newDimensions[index][field], unit: value };
        }
      } else {
        newDimensions[index][field] = { ...newDimensions[index][field], value: value };
      }
      return {
        ...prevValues,
        dimensions: newDimensions
      };
    });
  };

  const handleAddDimension = () => {
    setValues(prevValues => {
      const lastDimension = prevValues.dimensions[prevValues.dimensions.length - 1];
      const currentWeightUnit = lastDimension.weight.unit;
      const currentDimensionUnit = lastDimension.height.unit;
      return {
        ...prevValues,
        dimensions: [
          ...prevValues.dimensions,
          {
            weight: { value: "", unit: currentWeightUnit },
            length: { value: "", unit: currentDimensionUnit },
            width: { value: "", unit: currentDimensionUnit },
            height: { value: "", unit: currentDimensionUnit },
            quantity: { value: "" }
          }
        ]
      };
    });
  };

  const handleRemoveDimension = (index) => {
    if (values.dimensions.length > 1) {
      setValues(prevValues => ({
        ...prevValues,
        dimensions: prevValues.dimensions.filter((_, i) => i !== index)
      }));
    }
  };

  const validateForm = (formData) => {
    let errors = {};
    formData.dimensions.forEach((dimension, index) => {
      ["length", "width", "height", "weight", 'quantity'].forEach((dim) => {
        if (!dimension[dim].value || parseFloat(dimension[dim].value) <= 0) {
          errors[`${dim}-${index}`] = true;
        }
      });
    });
    if (!formData.selectedTemplate.name) {
      errors.selectedTemplate = "Please select a template";
    }
    formData.selectedTemplate.services.forEach((service, index) => {
      if (!service.description || service.description.trim() === "") {
        errors[`service_${index}_description`] = true;
      }
      if (service.values.length === 0) {
        errors[`service_${index}_values`] = true;
      }
      service.values.forEach((value, valueIndex) => {
        if (value === "") {
          errors[`service_${index}_value_${valueIndex}`] = true;
        }
      });
    });
    return errors;
  };

  const updateEstimateStatus = async (estimateId) => {
    try {
      const response = await api.patch(
        `${API_BASE_URL}/clientestimates/status/${estimateId}`,
        { status: true }
      );
    } catch (error) {
      console.error("Error updating estimate status:", error);
      toast.error("Failed to update estimate status. Please try again.");
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setAttemptedSubmit(true);
    const errors = validateForm(values);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error("Please fill in all required fields.");
      return;
    }
    try {
      setIsLoading(true);
      const existingEstimateResponse = await api.get(`${API_BASE_URL}/clientestimates/id/${estimateId}`);
      const existingEstimate = existingEstimateResponse.data;
      const existingDhlTaxes = existingEstimate.estimateSummary?.dhlTaxes || [];
      const estimateSummary = {
        total: Object.values(calculatedValues).reduce((sum, value) => sum + value, 0),
        currency: values.airfreightCurrency || "USD",
        services: values.selectedTemplate.services.map((service) => ({
          description: service.description,
          value: calculatedValues[service.description] || 0,
        })),
        dhlTaxes: existingDhlTaxes,
      };
      const dataToUpdate = {
        ...values,
        estimateSummary,
        countryCodes: `${getAlpha2Code(values.originCountry)}-${getAlpha2Code(values.destinationCountry)}`,
        estimationAccept: false,
        selectedTemplate: {
          ...values.selectedTemplate,
          services: values.selectedTemplate.services.map((service) => ({
            ...service,
            calculatedValue: calculatedValues[service.description] || 0,
          })),
        },
        dimensions: values.dimensions,
        itemsCurrency: values.itemsCurrency,
      };
      const updateResponse = await api.put(`${API_BASE_URL}/clientestimates/id/${estimateId}`, dataToUpdate);
      if (!updateResponse.data) {
        throw new Error(`Failed to update estimate: ${updateResponse.statusText}`);
      }
      await updateEstimateStatus(estimateId);
      const itemNames = values.items.map((item) => item.itemName);
      const formattedItemNames = itemNames.join(", ");
      try {
        const notificationResponse = await api.post(`${API_BASE_URL}/notifications`, {
          title: "Estimate is created",
          message: `Your estimate has been updated successfully for ${formattedItemNames}.`,
          linkText: "View Quote",
          link: `/estimate/${estimateId}`,
          role: "user",
          userId: values.userId,
          type: "estimate-generated",
        });
        if (notificationResponse.data.message.includes("quota limit")) {
          toast.warn("Estimate saved, but push notification delivery may be delayed due to quota limits.");
        }
      } catch (notificationError) {
        console.error("Notification error:", notificationError);
        if (notificationError.response?.status === 500 && notificationError.response?.data?.error?.includes("Quota")) {
          toast.warn("Estimate saved, but push notification failed due to quota limits.");
        } else {
          toast.error("Failed to send notification. Please try again later.");
        }
      }
      await api.post(`${API_BASE_URL}/mail/ior-notification-client`, {
        estimateData: values,
        clientEmail: values.email,
        link: `${API_DEPLOYED_URL}/estimate/${estimateId}`,
      });
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error during form submission:", error);
      if (error.response) {
        toast.error(`Server error: ${error.response.data.message || error.response.statusText}`);
      } else if (error.request) {
        toast.error("No response received from server. Please try again.");
      } else {
        toast.error(`An error occurred: ${error.message}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    navigate("/newRequest");
  };

  const closeModalNoMatch = () => {
    setIsNoMatchModalOpen(false);
  };

  const handleItemChange = (index, field, value) => {
    setValues((prevValues) => {
      const updatedItems = [...prevValues.items];
      updatedItems[index] = { ...updatedItems[index], [field]: value };
      return { ...prevValues, items: updatedItems };
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    if (attemptedSubmit) {
      setValidationErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const handleDimensionUnitChange = (unit) => {
    setValues((prevValues) => ({
      ...prevValues,
      dimensionUnit: unit,
      dimensions: prevValues.dimensions.map(dim => ({
        ...dim,
        length: { ...dim.length, unit },
        width: { ...dim.width, unit },
        height: { ...dim.height, unit }
      }))
    }));
  };

  const handleWeightUnitChange = (unit) => {
    setValues((prevValues) => ({
      ...prevValues,
      dimensions: prevValues.dimensions.map(dim => ({
        ...dim,
        weight: { ...dim.weight, unit }
      }))
    }));
  };

  const handleSelectChange = (name, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    if (attemptedSubmit) {
      setValidationErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const inputStyle = (fieldName) => `
    w-full h-8 p-2 text-sm border rounded-md outline-none 
    ${validationErrors[fieldName]
      ? "border-red-500"
      : "active:border-cus-blue focus:border-cus-blue"
    }
  `;

  const handleNoMatchConfirm = () => {
    setIsNoMatchModalOpen(false);
    navigate("/settings");
  };

  useEffect(() => {
    const fetchEccnCodes = async () => {
      try {
        const response = await api.get(`${API_BASE_URL}/eccn`);
        setEccnCodes(response.data);
      } catch (error) {
        console.error("Error fetching ECCN codes:", error);
        toast.error("Failed to load ECCN codes");
      }
    };
    fetchEccnCodes();
  }, []);

  const fetchEstimate = async (estimateId) => {
    try {
      const response = await api.get(`${API_BASE_URL}/clientestimates/id/${estimateId}`);
      const estimateData = response.data;
      // console.log("Fetched estimateData:", estimateData); // Debug log to verify itemsCurrency

      const eccnValue = estimateData.eccnCode || estimateData.eccn_code || estimateData.eccn;
      setValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          eccnCode: eccnValue,
          userName: estimateData.userName,
          userId: estimateData.userId,
          userCity: estimateData.userCity,
          userCountry: estimateData.userCountry,
          postalCode: estimateData.postalCode,
          email: estimateData.email,
          items: estimateData.items || [],
          loadCountry: estimateData.loadCountry,
          originCountry: estimateData.loadCountry,
          originCity: estimateData.originCity,
          destinationCity: estimateData.destinationCity,
          unloadCountry: estimateData.unloadCountry,
          destinationCountry: estimateData.unloadCountry,
          itemsCurrency: estimateData.itemsCurrency || "USD",
          hsCode: estimateData.hsCode,
          selectedService: estimateData.selectedService,
          insuranceSelected: estimateData.insuranceSelected || "NO",
          requiredDoc: estimateData.requiredDoc || "not_Required",
          dimensions: estimateData.dimensions || [{
            weight: { value: "", unit: "kg" },
            length: { value: "", unit: "cm" },
            width: { value: "", unit: "cm" },
            height: { value: "", unit: "cm" },
            quantity: { value: "" }
          }],
          dimensionUnit: estimateData.dimensions?.[0]?.length?.unit || "cm",
          status: estimateData.status,
          estimateSummary: estimateData.estimateSummary || { services: [], dhlTaxes: [] },
        };
        // console.log("Updated values:", updatedValues); // Debug log to verify itemsCurrency
        return updatedValues;
      });
      setSelectedEccn(eccnValue);
      if (estimateData.status) {
        setValues((prevValues) => ({
          ...prevValues,
          selectedTemplate: estimateData.selectedTemplate,
          airfreightCurrency: estimateData.airfreightCurrency,
          afcWeightUnit: estimateData.dimensions?.[0]?.weight?.unit || "kg",
        }));
        setCalculatedValues(
          estimateData.estimateSummary.services.reduce((acc, service) => {
            acc[service.description] = service.value;
            return acc;
          }, {})
        );
      } else {
        fetchAdminEstimate(
          estimateData.loadCountry,
          estimateData.unloadCountry,
          estimateData.selectedService,
          "kg", // Always pass "kg" instead of estimateData.dimensions?.[0]?.weight?.unit || "kg"
          estimateData.itemsCurrency
        );
      }
    } catch (error) {
      console.error("Error fetching estimate:", error);
      toast.error("Failed to load estimate data. Please try again.");
    }
  };

  const renderEccnOption = (eccn) => (
    <div className="flex flex-col py-2 px-3 hover:bg-blue-50 transition-colors">
      <div className="flex justify-between items-center">
        <span className="font-semibold text-blue-600">{eccn.eccn_code}</span>
        <span className={`text-xs px-2 py-1 rounded-full ${eccn.restrictions ? 'bg-red-100 text-red-600' : 'bg-green-100 text-green-600'}`}>
          {eccn.restrictions ? 'Restricted' : 'Unrestricted'}
        </span>
      </div>
      <span className="text-sm text-gray-600 mt-1">{eccn.description}</span>
    </div>
  );

  const calculateTotalInvoiceValue = (items) => {
    if (!items || !Array.isArray(items)) {
      return 0;
    }
    return items.reduce((total, item) => {
      const itemValue = parseFloat(item.itemValue) || 0;
      return total + itemValue;
    }, 0);
  };

  const calculateIORFee = (invoiceValue, percentage) => {
    return (invoiceValue * percentage) / 100;
  };

  const fetchAdminEstimate = async (loadCountry, unloadCountry, selectedService, weightUnit, itemsCurrency) => {
    try {
      // Always use "kg" for the API call regardless of the passed parameter
      const standardizedWeightUnit = "kg";

      // Use the new optimized endpoint with query parameters
      const response = await api.get(`${API_BASE_URL}/estimates/estimate-match`, {
        params: {
          loadCountry,
          unloadCountry,
          selectedService,
          weightUnit: standardizedWeightUnit, // Always pass "kg"
          itemsCurrency
        },
      });
      const estimateData = response.data;
      console.log("Optimized estimateData response:", estimateData);
      if (estimateData && estimateData.length > 0) {
        // Find exact match using the same logic as before, but with standardized weight unit
        const exactMatch = estimateData.find(
          (estimate) =>
            (Array.isArray(estimate.loadCountry)
              ? estimate.loadCountry.includes(loadCountry)
              : estimate.loadCountry === loadCountry) &&
            estimate.unloadCountry === unloadCountry &&
            estimate.selectedTemplate.name === selectedService &&
            estimate.afcWeightUnit === standardizedWeightUnit &&
            estimate.airfreightCurrency === itemsCurrency
        );
        console.log("exactMatch found:", exactMatch);
        if (exactMatch) {
          setValues((prevValues) => {
            const totalInvoiceValue = calculateTotalInvoiceValue(
              prevValues.items
            );
            let iorFee = 0;
            if (
              exactMatch.selectedTemplate &&
              exactMatch.selectedTemplate.services
            ) {
              const iorService = exactMatch.selectedTemplate.services.find(
                (service) => service.description === "IOR"
              );
              if (iorService && iorService.values.length === 3) {
                const percentage = parseFloat(iorService.values[2].value);
                iorFee = calculateIORFee(totalInvoiceValue, percentage);
              }
            }
            return {
              ...prevValues,
              airfreightCurrency: exactMatch.airfreightCurrency,
              afcWeightUnit: exactMatch.afcWeightUnit,
              selectedTemplate: exactMatch.selectedTemplate,
              iorFee: iorFee.toFixed(2),
              totalInvoiceValue: totalInvoiceValue.toFixed(2),
            };
          });
        } else {
          displayNoMatchWarning(loadCountry, unloadCountry);
        }
      } else {
        displayNoMatchWarning(loadCountry, unloadCountry);
      }
    } catch (error) {
      console.error("Error fetching admin estimate:", error);
      if (error.response?.status === 400) {
        toast.error("Invalid request parameters. Please check your input.", {
          position: "top-right",
          autoClose: 5000,
        });
      } else if (error.response?.status === 500) {
        toast.error("Server error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
        });
      } else {
        toast.error("Failed to load admin estimate data. Please try again.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
      displayNoMatchWarning(loadCountry, unloadCountry);
    }
  };

  const displayNoMatchWarning = (loadCountry, unloadCountry) => {
    setIsNoMatchModalOpen(true);
    setValues((prevValues) => ({
      ...prevValues,
      airfreightCharges: "",
      minimumAirfreightCharges: "",
      iorFee: "",
      minimumCharges: "",
      handlingFee: "",
      dutyPercentage: "",
      vatPercentage: "",
      selectedTemplate: "",
      originCharges: "",
      freightCost: "",
      services: [],
    }));
  };

  useEffect(() => {
    if (estimateId) {
      fetchEstimate(estimateId);
    }
  }, [estimateId]);

  useEffect(() => {
    if (
      values.loadCountry &&
      values.unloadCountry &&
      values.items &&
      values.itemsCurrency &&
      values.dimensions?.[0]?.weight?.unit &&
      values.selectedTemplate &&
      values.selectedTemplate.name &&
      !values.status
    ) {
      fetchAdminEstimate(
        values.loadCountry,
        values.unloadCountry,
        values.selectedService,
        "kg",
        values.itemsCurrency
      );
    }
  }, [values.loadCountry, values.unloadCountry, values.items, values.dimensions, values.status]);

  const onBack = () => {
    navigate("/newRequest?from=estimatedIOR");
  };

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      padding: "30px",
      borderRadius: "12px",
      maxWidth: "500px",
      width: "90%",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)",
      border: "none",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
  };

  const formatCurrency = (value, currency = 'USD') => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(value);
  };

  const getItemsTable = (items) => {
    return items.map((item, index) => [
      (index + 1).toString(),
      item.itemName,
      item.itemHSCode,
      item.quantity,
      formatCurrency(item.itemValue, values.itemsCurrency)
    ]);
  };

  const getServicesTable = (services, calculatedValues) => {
    return services.map(service => [
      service.description,
      formatCurrency(calculatedValues[service.description], values.airfreightCurrency)
    ]);
  };

  const fetchClientEstimateSummary = async (estimateId) => {
    try {
      const response = await api.get(`${API_BASE_URL}/clientestimates/summary/${estimateId}`);
      return response.data.estimateSummary;
    } catch (error) {
      console.error("Error fetching client estimate summary:", error);
      toast.error("Error fetching estimate summary");
      return null;
    }
  };

  const handleDownloadPdf = async () => {
    setDownloadLoading(true);
    try {
      const estimate = { ...values, estimateId };
      const clientEstimateSummary = await fetchClientEstimateSummary(estimateId);
      if (!clientEstimateSummary) {
        throw new Error("Failed to fetch estimate summary");
      }
      const dhlEstimation = {
        feeTotals: clientEstimateSummary.dhlTaxes?.map(tax => ({
          name: tax.name,
          value: tax.value
        })) || []
      };
      if (!clientEstimateSummary.services.length && !dhlEstimation.feeTotals.length) {
        toast.warn("Estimate data is incomplete. Unable to download PDF.");
        setDownloadLoading(false);
        return;
      }
      const pdfBlob = await generateIOR(estimate, clientEstimateSummary, dhlEstimation);
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `estimate_${estimate.estimateId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toast.error(`Error downloading PDF: ${error.message}`);
    } finally {
      setDownloadLoading(false);
    }
  };

  const removeItem = (index) => {
    setValues((prevValues) => ({
      ...prevValues,
      items: prevValues.items.filter((_, i) => i !== index),
    }));
  };

  const handleInsuranceChange = (e) => {
    const value = e.target.value;
    setValues(prevValues => ({
      ...prevValues,
      insuranceSelected: value
    }));
    const calculatedInsurance = value === 'YES' ? totalItemsValue * 0.0075 : 0;
    setInsurance(calculatedInsurance);
  };

  const handleRequiredDocChange = (e) => {
    const value = e.target.value;
    setValues(prevValues => ({
      ...prevValues,
      requiredDoc: value
    }));
  };

  useEffect(() => {
    const calculateTotalDimensions = () => {
      // Use conversion functions for accurate calculations
      const totalWeight = values.dimensions.reduce((sum, dim) => {
        const weightInKg = getWeightInKg(dim.weight);
        const quantity = parseFloat(dim.quantity.value || 0);
        return sum + (weightInKg * quantity);
      }, 0);
      const totalLength = values.dimensions.reduce((sum, dim) => {
        return sum + getDimensionInCm(dim.length);
      }, 0);
      const totalWidth = values.dimensions.reduce((sum, dim) => {
        return sum + getDimensionInCm(dim.width);
      }, 0);
      const totalHeight = values.dimensions.reduce((sum, dim) => {
        return sum + getDimensionInCm(dim.height);
      }, 0);
      setTotalDimensionsWeight(totalWeight);
      setTotalDimensionsLength(totalLength);
      setTotalDimensionsWidth(totalWidth);
      setTotalDimensionsHeight(totalHeight);
    };
    calculateTotalDimensions();
  }, [values.dimensions]);

  useEffect(() => {
    const calculateTotalValue = () => {
      const total = values.items.reduce((sum, item) => {
        const value = parseFloat(item.itemValue) || 0;
        const quantity = parseFloat(item.quantity) || 0;
        return sum + (value * quantity);
      }, 0);
      const totalQuantity = values.items.reduce((sum, item) => {
        const quantity = parseFloat(item.quantity) || 0;
        return sum + quantity;
      }, 0);
      setTotalItemsValue(total);
      setItemsTotalQty(totalQuantity);
    };
    calculateTotalValue();
  }, [values.items]);

  useEffect(() => {
    const calculateTotalQuantity = () => {
      const total = values.dimensions.reduce((sum, dim) => {
        return sum + (parseFloat(dim.quantity.value) || 0);
      }, 0);
      setTotalItemsQuantity(total);
    };
    calculateTotalQuantity();
  }, [values.dimensions]);

  useEffect(() => {
    const calculateAirfreight = () => {
      const totalVolumetricWeight = values.dimensions.reduce((sum, dim) => {
        const lengthCm = getDimensionInCm(dim.length);
        const widthCm = getDimensionInCm(dim.width);
        const heightCm = getDimensionInCm(dim.height);
        const quantity = parseFloat(dim.quantity.value || 0);
        let volWeight = (lengthCm * widthCm * heightCm) / 6000;
        return sum + (volWeight * quantity);
      }, 0);
      const chargeableWeight = Math.max(totalVolumetricWeight, totalDimensionsWeight);
      let airfreightCost;
      if (chargeableWeight < 360) {
        airfreightCost = 6.50 * chargeableWeight + 250;
      } else if (chargeableWeight >= 360 && chargeableWeight <= 1080) {
        airfreightCost = 5.00 * chargeableWeight + 250;
      } else {
        airfreightCost = 4.00 * chargeableWeight + 250;
      }
      setAirfreight(airfreightCost);
    };
    calculateAirfreight();
  }, [values.dimensions, totalDimensionsWeight]);

  useEffect(() => {
    const calculateInsurance = () => {
      const calculatedInsurance = values.insuranceSelected === 'YES' ? totalItemsValue * 0.0075 : 0;
      setInsurance(calculatedInsurance);
    };
    calculateInsurance();
  }, [values.insuranceSelected, totalItemsValue]);

  useEffect(() => {
    const calculateCIF = () => {
      const calculatedCIF = totalItemsValue + airfreight + insurance;
      setCif(calculatedCIF);
    };
    calculateCIF();
  }, [totalItemsValue, airfreight, insurance]);

  const [calculatedValues, setCalculatedValues] = useState({});

  useEffect(() => {
    const calculateValuesWithCurrency = async () => {
      if (values.selectedTemplate && values.selectedTemplate.services) {
        const userCurrency = await getUserCurrency(values.userId);
        const currencyObj = currencies.find((c) => c.name === userCurrency);
        const exchangeRateUSD = currencyObj ? currencyObj.exchangeRateUSD : 1;
        const newCalculatedValues = {};
        values.selectedTemplate.services.forEach((service) => {
          const adjustedTotalItemsValue =
            userCurrency === currencyObj?.name
              ? totalItemsValue * exchangeRateUSD
              : totalItemsValue;
          newCalculatedValues[service.description] = calculateServiceValue(
            service,
            values,
            newCalculatedValues,
            adjustedTotalItemsValue,
            totalDimensionsWeight,
            totalDimensionsLength,
            totalDimensionsWidth,
            totalDimensionsHeight,
            cif,
            insurance,
            totalItemsQuantity,
            itemsTotalQty
          );
        });
        setCalculatedValues(newCalculatedValues);
      }
    };
    calculateValuesWithCurrency();
  }, [values, currencies]);

  return (
    <>
      <DashboardLayout>
        <div className="w-full">
          <Header title="Estimated IOR" />
          <div className="mb-3 p-4">
            <button
              type="button"
              onClick={onBack}
              className="flex rounded-[5px] items-center space-x-4 py-2 px-4 text-white btnBg">
              <FaArrowLeft className="mr-2" /> Back
            </button>
          </div>
          <div className="p-4 bg-cus-gray">
            <form
              onSubmit={handleFormSubmit}
              className="p-4 mx-auto bg-white border rounded-md"
            >
              <div className="mx-[30px] flex flex-wrap md:flex-nowrap gap-3 mt-4">
                <div className="w-full md:w-1/2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadCountry"
                  >
                    Load Country <span className="text-red-500">*</span>
                  </label>
                  <CountrySelectInput
                    name="loadCountry"
                    id="loadCountry"
                    placeholder="Select Country"
                    value={values.loadCountry}
                    onChange={handleChange}
                    error={validationErrors.loadCountry}
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="unloadCountry"
                  >
                    Unload Country <span className="text-red-500">*</span>
                  </label>
                  <CountrySelectInput
                    name="unloadCountry"
                    id="unloadCountry"
                    value={values.unloadCountry}
                    placeholder="Select Country"
                    onChange={handleChange}
                    error={validationErrors.unloadCountry}
                  />
                </div>
              </div>
              <div className="mx-[30px] flex flex-wrap md:flex-nowrap gap-3 mt-4">
                <div className="w-full md:w-1/2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="originCity"
                  >
                    Load City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className={inputStyle("originCity")}
                    id="originCity"
                    name="originCity"
                    value={values.originCity}
                    onChange={handleChange}
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="destinationCity"
                  >
                    Unload City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    className={inputStyle("destinationCity")}
                    id="destinationCity"
                    name="destinationCity"
                    value={values.destinationCity}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="space-y-4 mt-8">
                {values.dimensions.map((dimension, index) => (
                  <div key={index} className="relative border p-4 rounded-md">
                    <div className="grid grid-cols-5 gap-4">
                      {/* Weight Field */}
                      <div className="flex flex-col gap-1">
                        <label className="text-sm font-normal" htmlFor={`weight-${index}`}>
                          Weight <span className="text-red-500">*</span>
                        </label>
                        <div className="flex items-center gap-2">
                          <input
                            type="number"
                            className={`w-28 p-1 text-sm border rounded-md outline-none ${validationErrors[`weight-${index}`]
                              ? "border-red-500"
                              : "active:border-cus-blue focus:border-cus-blue"
                              }`}
                            name={`weight-value-${index}`}
                            id={`weight-${index}`}
                            onChange={(e) => handleDimensionChange(index, 'weight', e)}
                            value={dimension.weight.value}
                            min="0"
                            step="0.01"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                          <select
                            className="p-1 text-sm border rounded-md outline-none"
                            name={`weight-unit-${index}`}
                            onChange={(e) => handleDimensionChange(index, 'weight', e)}
                            value={dimension.weight.unit}
                          >
                            <option value="kg">kg</option>
                            <option value="lbs">lbs</option>
                          </select>
                        </div>
                      </div>

                      {/* Length, Width, Height Fields */}
                      {["length", "width", "height"].map((dim) => (
                        <div key={dim} className="flex flex-col gap-1">
                          <label className="text-sm font-normal" htmlFor={`${dim}-${index}`}>
                            {dim.charAt(0).toUpperCase() + dim.slice(1)} <span className="text-red-500">*</span>
                          </label>
                          <div className="flex items-center gap-2">
                            <input
                              type="number"
                              className={`w-28 p-1 text-sm border rounded-md outline-none ${validationErrors[`${dim}-${index}`]
                                ? "border-red-500"
                                : "active:border-cus-blue focus:border-cus-blue"
                                }`}
                              name={`${dim}-value-${index}`}
                              id={`${dim}-${index}`}
                              onChange={(e) => handleDimensionChange(index, dim, e)}
                              value={dimension[dim].value}
                              min="0"
                              step="0.01"
                              onKeyDown={(e) => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            {dim === "height" && (
                              <select
                                className="p-1 text-sm border rounded-md outline-none"
                                name={`${dim}-unit-${index}`}
                                onChange={(e) => handleDimensionChange(index, dim, e)}
                                value={dimension[dim].unit}
                              >
                                <option value="cm">cm</option>
                                <option value="in">in</option>
                              </select>
                            )}
                          </div>
                        </div>
                      ))}

                      {/* Quantity Field */}
                      <div className="flex flex-col gap-1">
                        <label className="text-sm font-normal" htmlFor={`quantity-${index}`}>
                          Quantity <span className="text-red-500">*</span>
                        </label>
                        <div className="flex items-center">
                          <input
                            type="number"
                            className={`w-28 p-1 text-sm border rounded-md outline-none ${validationErrors[`quantity-${index}`]
                              ? "border-red-500"
                              : "active:border-cus-blue focus:border-cus-blue"
                              }`}
                            name={`quantity-value-${index}`}
                            id={`quantity-${index}`}
                            onChange={(e) => handleDimensionChange(index, 'quantity', e)}
                            value={dimension.quantity.value}
                            min="1"
                            step="1"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Add/Remove Dimension Buttons */}
                    <div className="absolute right-2 top-2 flex space-x-2">
                      {index === values.dimensions.length - 1 && (
                        <button
                          type="button"
                          onClick={handleAddDimension}
                          className="px-2 py-1 text-sm bg-green-500 text-white rounded hover:bg-blue-600"
                        >
                          <FaCirclePlus />
                        </button>
                      )}
                      {values.dimensions.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemoveDimension(index)}
                          className="px-2 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
                        >
                          <FaCircleMinus />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="mx-[30px] flex flex-wrap md:flex-nowrap gap-3 mt-4">
                {/* Insurance Selected section */}
                <div className="w-full md:w-1/2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Insurance Selected by Client <span className="text-red-500">*</span>
                  </label>
                  <Radio.Group onChange={handleInsuranceChange} value={values.insuranceSelected}>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                  </Radio.Group>
                </div>

                {/* Conditional rendering based on selectedService */}
                <div className="w-full md:w-1/2 space-y-6">
                  {/* ECCN Code - Show if selectedService includes 'EOR' */}
                  {(values.selectedService === "EOR" || values.selectedService === "EOR & IOR") && (
                    <div>
                      <label htmlFor="eccnCode" className="block text-sm font-medium text-gray-700 mb-2">
                        ECCN Code <span className="text-red-500">*</span>
                      </label>
                      <Select
                        showSearch
                        placeholder="Select ECCN Code"
                        value={selectedEccn}
                        onChange={(value) => {
                          setSelectedEccn(value);
                          setValues(prev => ({
                            ...prev,
                            eccnCode: value
                          }));
                        }}
                        className={validationErrors.eccnCode ? "border-red-500" : ""}
                        style={{ width: "100%" }}
                        optionLabelProp="label"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.props.children.some(child =>
                            child.toString().toLowerCase().includes(input.toLowerCase())
                          )
                        }
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                      >
                        {eccnCodes.map((eccn) => (
                          <Select.Option
                            key={eccn.eccn_code}
                            value={eccn.eccn_code}
                            label={eccn.eccn_code}
                          >
                            {renderEccnOption(eccn)}
                          </Select.Option>
                        ))}
                      </Select>
                      {validationErrors.eccnCode && (
                        <p className="text-red-500 text-xs mt-1">
                          ECCN Code is required for EOR service
                        </p>
                      )}
                    </div>
                  )}

                  {/* Document Required - Show if selectedService includes 'IOR' */}
                  {(values.selectedService === "IOR" || values.selectedService === "EOR & IOR") && (
                    <div>
                      <label htmlFor="requiredDoc" className="block text-sm font-medium text-gray-700 mb-2">
                        Import documentation required? <span className="text-red-500">*</span>
                      </label>
                      <Radio.Group
                        onChange={handleRequiredDocChange}
                        value={values.requiredDoc}
                      >
                        <Radio value="Required">Required</Radio>
                        <Radio value="not_Required">Not Required</Radio>
                      </Radio.Group>
                    </div>
                  )}
                </div>
              </div>
              <div className="mx-[30px] mt-8">
                <div>
                  <div>
                    <h2 className="text-xl font-bold mb-4">Item Details</h2>
                  </div>
                  <div className="flex items-center gap-2 w-[1/8] mb-6">
                    <h1 className="mt-2">Currency</h1>
                    <select
                      className="p-1 w-30 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      name="itemsCurrency"
                      id="itemsCurrency"
                      onChange={(e) => handleSelectChange("itemsCurrency", e.target.value)}
                      value={values.itemsCurrency} // This should reflect the fetched value
                    >
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                      <option value="GBP">GBP</option>
                    </select>
                  </div>
                </div>
                {values.items.map((item, index) => (
                  <div key={index} className="mb-6 p-4 border rounded-lg">
                    <div className="flex justify-between items-center mb-2">
                      <h3 className="text-lg font-semibold">
                        Item {index + 1}
                      </h3>
                      <Button
                        onClick={() => removeItem(index)}
                        icon={<FaCircleMinus />}
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Item Name <span className="text-red-500">*</span>
                        </label>
                        <Input
                          value={item.itemName}
                          onChange={(e) =>
                            handleItemChange(index, "itemName", e.target.value)
                          }
                          className={inputStyle("itemName")}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Item Value <span className="text-red-500">*</span>
                        </label>
                        <Input
                          type="number"
                          value={item.itemValue}
                          onChange={(e) =>
                            handleItemChange(index, "itemValue", e.target.value)
                          }
                          className={inputStyle("itemValue")}
                        />
                      </div>
                      <div>
                        <label
                          className="w-full text-sm font-normal"
                          htmlFor={`countryOrigin-${index}`}
                        >
                          Country of Origin{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <CountrySelectInput
                          name={`countryOrigin-${index}`}
                          id={`countryOrigin-${index}`}
                          placeholder="Select Country"
                          value={item.countryOrigin}
                          onChange={(e) => {
                            const value = e.target.value;
                            handleItemChange(index, "countryOrigin", value);
                          }}
                          error={validationErrors[`countryOrigin-${index}`]}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Quantity <span className="text-red-500">*</span>
                        </label>
                        <Input
                          type="number"
                          value={item.quantity}
                          onChange={(e) =>
                            handleItemChange(index, "quantity", e.target.value)
                          }
                          className={inputStyle("quantity")}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          HS Code <span className="text-red-500">*</span>
                        </label>
                        <Input
                          type="number"
                          value={item.itemHSCode}
                          onChange={(e) =>
                            handleItemChange(index, "hsCode", e.target.value)
                          }
                          className={inputStyle("hsCode")}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Is New Item <span className="text-red-500">*</span>
                        </label>
                        <div className="flex space-x-4">
                          <label className="inline-flex items-center">
                            <input
                              type="radio"
                              className="form-radio"
                              name={`itemNew-${index}`}
                              value="true"
                              checked={item.itemNew === true}
                              onChange={() =>
                                handleItemChange(index, "itemNew", true)
                              }
                            />
                            <span className="ml-2">Yes</span>
                          </label>
                          <label className="inline-flex items-center">
                            <input
                              type="radio"
                              className="form-radio"
                              name={`itemNew-${index}`}
                              value="false"
                              checked={item.itemNew === false}
                              onChange={() =>
                                handleItemChange(index, "itemNew", false)
                              }
                            />
                            <span className="ml-2">No</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <ServiceTempIOR
                formData={values}
                setFormData={setValues}
                setTemplateSelected={setTemplateSelected}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                savedServices={savedServices}
                setSavedServices={setSavedServices}
                calculatedValues={calculatedValues}
              />
              <div className="w-full flex justify-center mb-10">
                <div className="w-full lg:w-[40%] bg-[#FBFCFF] p-4 border rounded-lg border-cus-blue">
                  <h3 className="text-lg font-bold mb-3">Estimate Summary</h3>

                  {/* Services Section */}
                  <div className="mb-4">
                    <h4 className="text-[16px] font-semibold mb-2">Services</h4>
                    {values.estimateSummary?.services?.map((service, index) => (
                      (service.description !== 'Insurance' || values.insuranceSelected === 'YES') && (
                        <div key={index} className="flex justify-between mt-2">
                          <p className="text-[14px]">{service.description}</p>
                          <p className="text-[14px] font-extrabold">
                            {service.value.toFixed(2)} {values.airfreightCurrency}
                          </p>
                        </div>
                      )
                    ))}

                    {/* Subtotal */}
                    <div className="flex justify-between mt-4 border-t border-cus-blue pt-2">
                      <p className="text-[14px] font-semibold">Subtotal</p>
                      <p className="text-[14px] font-extrabold">
                        {values.estimateSummary?.services?.reduce((sum, service) => {
                          if (service.description !== 'Insurance' || values.insuranceSelected === 'YES') {
                            return sum + service.value;
                          }
                          return sum;
                        }, 0).toFixed(2) || '0.00'} {values.airfreightCurrency}
                      </p>
                    </div>
                  </div>

                  {/* Duty, VAT and Taxes Section */}
                  <div>
                    <h4 className="text-[16px] font-semibold mb-2">Duties and Taxes</h4>
                    {values.estimateSummary?.dhlTaxes?.map((tax, index) => (
                      <div key={index} className="flex justify-between mt-2">
                        <p className="text-[14px]">{tax.name}</p>
                        <p className="text-[14px] font-extrabold">
                          {tax.value.toFixed(2)} {values.airfreightCurrency}
                        </p>
                      </div>
                    ))}

                    {/* Total Taxes */}
                    <div className="flex justify-between mt-4 border-t border-cus-blue pt-2">
                      <p className="text-[14px] font-semibold">Total Taxes</p>
                      <p className="text-[14px] font-extrabold">
                        {values.estimateSummary?.dhlTaxes?.reduce((sum, tax) => sum + tax.value, 0).toFixed(2) || '0.00'}
                        {values.airfreightCurrency}
                      </p>
                    </div>
                  </div>

                  {/* Grand Total */}
                  <div className="flex justify-between mt-4 border-t border-cus-blue pt-2">
                    <p className="text-[14px] font-bold">Grand Total</p>
                    <p className="text-[14px] font-extrabold">
                      {(values.estimateSummary?.total || 0).toFixed(2)} {values.airfreightCurrency}
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="mx-[30px] flex flex-col gap-3 sm:flex-row justify-between mt-4">
                <div className="flex gap-2 items-center">
                  <CustomButton
                    label="Save and Send"
                    onClick={handleFormSubmit}
                    loading={isLoading}
                  />
                </div>
                <PDFDownloadButton
                  onClick={handleDownloadPdf}
                  loading={downloadLoading}
                />
              </div> */}
              <div className="mx-[30px] flex justify-center mt-4">
                <div className="flex gap-2 items-center">
                  <PDFDownloadButton
                    onClick={handleDownloadPdf}
                    loading={downloadLoading}
                    className="btnBg text-white font-bold py-3 px-6 rounded text-base"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </DashboardLayout>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Estimate Submission Confirmation"
      >
        <div className="text-center">
          <FaCheckCircle className="text-green-500 text-5xl mb-4 mx-auto" />
          <h2 className="text-2xl font-bold mb-4 text-gray-800">
            Estimate Approved Successfully!
          </h2>
          <p className="mb-6 text-gray-600">
            Estimation has been approved by you. Client will receive an email
            and a notification in their dashboard.
          </p>
          <button
            onClick={closeModal}
            className="bg-cus-blue hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          >
            Close
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={isNoMatchModalOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="No Match Warning"
      >
        <div className="relative">
          <button
            onClick={closeModalNoMatch}
            className="absolute top-0 right-0 m-2 text-gray-600 hover:text-gray-800"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="flex flex-col items-center justify-center h-full text-center pt-8">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">
              Estimations Data Not Found
            </h2>
            <p className="mb-6">
              No exact estimation data present for {values.loadCountry} to{" "}
              {values.unloadCountry}.
            </p>
            <div className="flex space-x-6 mt-4">
              <button
                className="btnBg text-white font-bold py-3 px-4 rounded w-36 "
                onClick={handleNoMatchConfirm}
              >
                Add Data
              </button>
              <button
                className="btnBg text-white font-bold py-3 px-4 rounded w-36 "
                onClick={closeModalNoMatch}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EstimatedIOR;